module.exports = __webpack_public_path__ + "static/media/marker_pay_selected.02995020.svg";